import * as React from 'react';
import { observable } from 'mobx';
import compute from '@src/components/vm-component/compute';
import entry from '@src/components/vm-component/entry';
import mapper from '@src/components/vm-component/mapper';

function business(vmInstance) {
  const { viewState, computes, mappers, entry: _entry } = vmInstance;

  if (viewState) {
    vmInstance.viewState = observable(viewState);
  }

  if (computes) {
    compute(vmInstance, 'computes');
  }

  if (_entry) {
    entry(vmInstance, 'entry');
  }

  if (mappers) {
    mapper(vmInstance, 'mappers');
  }

  return vmInstance;
}

const VMComponent = VM => {
  return class extends React.Component {
    constructor(props, context) {
      super(props, context);
      this.vm = business(new VM(this));
    }
  };
};

export default VMComponent;



// WEBPACK FOOTER //
// ./src/components/vm-component/index.js